import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChange,
    SimpleChanges,
} from '@angular/core';
import { GridDataResult, SortSettings } from '@progress/kendo-angular-grid';
import { orderBy, SortDescriptor } from '@progress/kendo-data-query';
import { MatDialog } from '@angular/material/dialog';
import { DistributionAnalyzeDialogComponent } from 'app/modules/settings/components/kpi-distribution-analyze-dialog/distribution-analyze-dialog.component';
import { CurrentUserStateService } from 'app/modules/shared/services/current-user-state.service';
import { ImpersonationService } from 'app/modules/shared/services/impersonation.service';
import { BehaviorSubject } from 'rxjs';
import {
    IDistributionDialogData,
    IKPIConfigData,
} from 'app/modules/settings/services/kpi-config.service';
import { KpiVersionDialogComponent } from '../kpi-version-dialog/kpi-version-dialog.component';
import { UserService } from 'app/modules/shared/services/user.service';
import { KpiDistributionAnalysisService } from 'app/modules/settings/services/kpi-distribution-analysis.service';
import { ToastService } from 'app/modules/shared/services/toast.service';
import { NoDataActionType } from 'app/modules/shared/interfaces/no-data';
import { ITableColumns } from 'app/modules/reports/interfaces/reporting-data';
import {
    ICellClickEventInfo,
    ICustomTableInfoExtend,
} from 'app/modules/shared/components/custom-mat-table/custom-mat-table.component';
import { CustomMatTableService } from 'app/modules/shared/services/custom-mat-table.service';

@Component({
    selector: 'app-kpi-config-one',
    templateUrl: './kpi-config-one.component.html',
    styleUrls: ['./kpi-config-one.component.scss'],
})
export class KpiConfigOneComponent implements OnInit, OnChanges, OnDestroy {
    grid: GridDataResult;
    sortable: SortSettings = {
        mode: 'single',
        allowUnsort: true,
    };

    sort: SortDescriptor[] = [
        {
            field: 'clientKPIDescription',
            dir: 'asc',
        },
    ];

    allResults: boolean = false;
    scrollable = 'scrollable';
    isSuperUser: boolean;
    isPowerUser: boolean;

    columnInfoList: ITableColumns[];
    customTableInfo: ICustomTableInfoExtend;
    searchTerm: string;
    action: NoDataActionType;
    analyticButtonDisableId = 'isAnalyticIconDisableKey';
    analyticButtonTitleId = 'analyticIconTitle';
    isActiveCheckboxTitleId = 'checkboxTitle1';

    @Input() data: IKPIConfigData[];
    @Input() loading: boolean;
    @Output() updatedKPIfData = new EventEmitter<IKPIConfigData[]>();
    private returnDataFromRetrieveDialog = new BehaviorSubject<IKPIConfigData>(
        {} as IKPIConfigData
    );

    constructor(
        private cdr: ChangeDetectorRef,
        private distributionAnalyzeDialog: MatDialog,
        private matDialog: MatDialog,
        private currentUserStateService: CurrentUserStateService,
        private impersonationService: ImpersonationService,
        private userService: UserService,
        private _distributionService: KpiDistributionAnalysisService,
        private _toastService: ToastService,
        private _customMatTableService: CustomMatTableService
    ) {}

    ngOnInit() {
        this.isSuperUser = this.currentUserStateService.isLBASuperUser();

        if (this.impersonationService.isImpersonatingClient()) {
            if (this.impersonationService.isImpersonatingUser()) {
                var clientUser = this.impersonationService.impersonateUser;

                this.userService.getUserByEmail(clientUser).subscribe((data) => {
                    this.isSuperUser = data.isSuperUser;
                });
            }
        }

        this.searchTerm = '';
        this.action = NoDataActionType.pageStart;
        //this.initiateTableProperties();
        //console.log('no-onint');
        //console.log(this.data);

        // this.customTableInfo.dataSet = [];
        // this.customTableInfo = this._customMatTableService.refreshCustomMatTable(
        //     this.customTableInfo,
        //     false,
        //     false,
        //     this.action,
        //     this.searchTerm
        // );
        //this.cdr.detectChanges();
        //this.loadGrid();
    }

    // ngOnChanges(changes: SimpleChanges) {
    //     this.initiateTableProperties();
    //     if (changes?.data?.previousValue == undefined && changes?.data?.currentValue != undefined) {
    //         this.loadGrid();
    //         //this.cdr.detectChanges();
    //     }
    // }

    ngOnChanges(changes: { [property: string]: SimpleChange }) {
        //this.initiateTableProperties();
        // if (changes?.data?.previousValue == undefined && changes?.data?.currentValue != undefined) {
        //     this.loadGrid();
        //     //this.cdr.detectChanges();
        // }
        this.initiateTableProperties();
        //console.log('before chabge');
        // console.log(this.data);
        let dataChanges = changes['data'];
        this.cdr.detectChanges();
        // if (dataChanges) {
        //     console.log('after chabge');
        //     console.log(this.data);
        //     this.data = dataChanges.currentValue;
        //     this.loadGrid();
        // }

        if (dataChanges?.currentValue && this.customTableInfo) {
            //console.log('dataChanges', dataChanges);

            this.loadGrid();
        }
    }

    initiateTableProperties() {
        this.columnInfoList = [
            {
                fieldId: 'isActive',
                fieldName: '',
                dataType: 'input',
                dataInputProperties: {
                    dataInputType: 'checkbox',
                    key: 'isActive',
                    valueKey: 'type',
                    disableKey: 'isLocked',
                    isCellDependentDdl: false,
                    widthPercent: 50,
                    descriptionKey: this.isActiveCheckboxTitleId,
                },
                fieldOrder: 0,
                isSortable: true,
                headerAlignment: 'left',
                dataAlignment: 'left',
                width: 80,
            },
            {
                fieldId: 'clientKPIDescription',
                fieldName: 'Key Performance Indicator',
                fieldOrder: 1,
                isSortable: true,
                defaultSorting: 'asc',
                headerAlignment: 'left',
                dataAlignment: 'left',
                width: 300,
                dataType: 'string',
            },
            {
                fieldId: 'kpiCategory',
                fieldName: 'Category',
                fieldOrder: 1.5,
                isSortable: true,
                headerAlignment: 'left',
                dataAlignment: 'left',
                width: 100,
                dataType: 'string',
            },
            {
                fieldId: 'bestScore',
                fieldName: 'Best Score',
                fieldOrder: 2,
                isSortable: true,
                headerAlignment: 'left',
                dataAlignment: 'left',
                width: 150,
                dataType: 'string',
            },
            {
                fieldId: 'target',
                fieldName: 'Target',
                fieldOrder: 3,
                isSortable: true,
                headerAlignment: 'left',
                dataAlignment: 'left',
                width: 120,
                dataType: 'input',
                dataInputProperties: {
                    dataInputType: 'textInput',
                    key: 'target',
                    valueKey: '',
                    disableKey: '',
                    errorKey: 'targetError',
                    isCellDependentDdl: false,
                    widthPercent: 60,
                    textInputType: 'number',
                },
            },
            {
                fieldId: 'isWeightedByLA',
                fieldName: 'Weighted By Loan Amount',
                fieldOrder: 4,
                isSortable: true,
                headerAlignment: 'left',
                dataAlignment: 'left',
                width: 120,
                dataType: 'input',
                dataInputProperties: {
                    dataInputType: 'checkbox',
                    key: 'isWeightedByLA',
                    valueKey: 'type',
                    disableKey: 'isWeightedByLADisabled',
                    isCellDependentDdl: false,
                    widthPercent: 50,
                },
            },
            {
                fieldId: 'distributionBtn',
                fieldName: 'Analytics',
                fieldOrder: 5,
                isSortable: true,
                headerAlignment: 'left',
                dataAlignment: 'left',
                width: 70,
                dataType: 'icon',
                cellClickEventType: 'iconClick',
                iconProperties: {
                    descriptionKey: this.analyticButtonTitleId,
                    iconClass: 'fas fa-chart-line',
                    iconStyle: {
                        'font-size': '20px',
                    },
                    iconDisableKey: this.analyticButtonDisableId,
                },
            },
        ];

        this.customTableInfo = {
            tableId: 'kpi-performance-setup-1-table',
            tableHeight: 600,
            hasData: false,
            isDataReady: false,
            columnInfoList: this.columnInfoList,
            dataSet: [],
            searchTerm: this.searchTerm,
            action: this.action,
            title: 'Key Performance Indicator Setup 1',
            bandColorList: [],
            dataHandleInUiSide: true,
            showSummary: false,
        };
        this.customTableInfo.dataSet = [];
        this.customTableInfo = this._customMatTableService.refreshCustomMatTable(
            this.customTableInfo,
            false,
            false,
            this.action,
            this.searchTerm
        );
    }

    cellClickedEvent(event: ICellClickEventInfo) {
        if (
            event.columnInfo?.cellClickEventType === 'iconClick' &&
            event.columnInfo?.fieldId === 'distributionBtn'
        ) {
            this.openDistributionAnalyzeDialog(event.cellData);
        }
    }

    contentChanged(events: IKPIConfigData[]) {
        if (events?.length > 0) {
            this.columnInfoList.forEach((col) => {
                events.map((event) => {
                    if (col.fieldId === 'isActive') {
                        event[this.isActiveCheckboxTitleId] = event.isLocked
                            ? 'KPI locked because it is used in KPI Profile'
                            : event.isActive
                            ? 'Enabled'
                            : 'Disabled';
                        event[this.analyticButtonTitleId] = this.getAnalyticIconTooltip(event);
                        event[this.analyticButtonDisableId] =
                            !event.ddbiAvailable || !event.isActive;
                    }

                    if (
                        col.dataType === 'input' &&
                        col.dataInputProperties?.dataInputType === 'textInput'
                    ) {
                        event[col.dataInputProperties?.errorKey] = this.targetErrorMessage(event);
                    }
                });
            });
        }
    }

    inputChangeEvent(event: ICellClickEventInfo) {
        let col = event.columnInfo;
        if (col?.dataType === 'input' && col?.dataInputProperties?.dataInputType === 'textInput') {
            event.cellData[col.dataInputProperties?.errorKey] = this.targetErrorMessage(
                event.cellData
            );
            console.log(event);
        }
    }

    loadGrid() {
        // try {
        //     this.grid = {
        //         data: orderBy(this.data, this.sort),
        //         total: this.data.length,
        //     };
        // } catch (e) {}

        if (this.customTableInfo) {
            this.customTableInfo.dataSet = [];
            this.customTableInfo = this._customMatTableService.refreshCustomMatTable(
                this.customTableInfo,
                false,
                false,
                this.action,
                this.searchTerm
            );

            if (this.data?.length > 0) {
                this.customTableInfo.dataSet = this.data;
                this.customTableInfo = this._customMatTableService.refreshCustomMatTable(
                    this.customTableInfo,
                    true,
                    true,
                    this.action,
                    this.searchTerm
                );
            } else {
                this.customTableInfo.dataSet = [];
                this.customTableInfo = this._customMatTableService.refreshCustomMatTable(
                    this.customTableInfo,
                    false,
                    true,
                    this.action,
                    this.searchTerm
                );
            }
        }
    }

    // sortChange(sort: SortDescriptor[]): void {
    //     this.sort = sort;
    //     this.loadGrid();
    // }

    // isInvalid(row) {
    //     row.errors = [];
    //     let result = false;
    //     row.targetError = false;
    //
    //     if (row.isActive && (!row.target || row.target == 0)) {
    //         row.errors = ['Target value cannot be empty or zero.'];
    //         row.targetError = true;
    //         result = true;
    //     }
    //
    //     return result;
    // }

    targetErrorMessage(row) {
        let error = '';
        if (!row.target || +row.target === 0) {
            error = 'Target value cannot be empty or zero.';
        }
        return error;
    }

    openDistributionAnalyzeDialog(dataItem) {
        if (dataItem[this.analyticButtonDisableId]) {
            return;
        }
        this.returnDataFromRetrieveDialog = new BehaviorSubject<IKPIConfigData>(
            {} as IKPIConfigData
        );
        let returnDataFromRetrieveDialog$ = this.returnDataFromRetrieveDialog.asObservable();
        let data: IDistributionDialogData = {
            dataBackToParent: this.returnDataFromRetrieveDialog,
            dataToChild: dataItem,
        };
        let dialogRef = this.distributionAnalyzeDialog.open(DistributionAnalyzeDialogComponent, {
            data: data,
        });
        returnDataFromRetrieveDialog$.subscribe((value: IKPIConfigData) => {
            // TODO: Figure out why ClientKPIKey is not set after setting a KPI.
            //  Then use ClientKPIKey instead of clientKPIDescription
            if (value && value.clientKPIDescription) {
                let updatedRowCount = 0;
                this.data.map((item) => {
                    if (
                        item.clientKPIDescription === value.clientKPIDescription &&
                        item.milestoneKey === value.milestoneKey &&
                        item.kpiMasterKey === value.kpiMasterKey &&
                        item.kpiMilestoneKey === value.kpiMilestoneKey
                    ) {
                        item.range1End = value.range1End;
                        item.range2Start = value.range2Start;
                        item.range2End = value.range2End;
                        item.range3Start = value.range3Start;
                        item.range3End = value.range3End;
                        item.range4Start = value.range4Start;
                        item.range4End = value.range4End;
                        item.range5Start = value.range5Start;
                        item.target = value.target;
                        updatedRowCount += 1;
                    }
                });
                if (updatedRowCount === 1) {
                    this.updatedKPIfData.emit(this.data);
                } else {
                    throw Error(`Only one row must be updated. There are ${updatedRowCount} rows.`);
                }
            }
        });
    }

    closeDistributionAnalyzeDialog() {
        //this.dialogParametrs?.dialogref?.close();
    }

    ngOnDestroy() {
        this.returnDataFromRetrieveDialog.unsubscribe();
    }

    openTimeboxDialog(dataItem) {
        const dialogRef = this.matDialog.open(KpiVersionDialogComponent, {
            data: { dialogData: this.data, dialogItem: dataItem },
            panelClass: 'kpi-version-dialog',
        });
    }

    getAnalyticIconTooltip(dataItem: IKPIConfigData) {
        let tooltip = '';
        if (!dataItem.ddbiAvailable) {
            tooltip += 'Historical data is not available.';
        }
        if (!dataItem.isActive) {
            let separator = !dataItem.ddbiAvailable ? ' ' : '';
            tooltip += separator + 'This KPI is not enabled.';
        }

        if (dataItem.isActive && dataItem.ddbiAvailable) {
            tooltip = 'Click to get analytics.';
        }
        return tooltip;
    }
}
